export enum EmployeeDataChangeRequestStatus {
Pending,
Accepted,
Rejected,
}
